import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImportedInvoiceDetailRowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.S16};
  justify-content: space-between;
  padding: ${Spacing.S12} 0;
  border-bottom: 1px solid ${Color.Grey100};

  &:last-child {
    border-bottom: none;
  }
`
